const VARIANTS = {
  success:  "bg-emerald-50 text-emerald-700 border-emerald-200",
  warning:  "bg-amber-50 text-amber-700 border-amber-200",
  error:    "bg-red-50 text-red-700 border-red-200",
  premium:  "bg-violet-50 text-violet-700 border-violet-200",
  free:     "bg-slate-100 text-slate-600 border-slate-200",
  admin:    "bg-indigo-50 text-indigo-700 border-indigo-200",
  running:  "bg-amber-50 text-amber-700 border-amber-200",
  idle:     "bg-slate-100 text-slate-500 border-slate-200",
  active:   "bg-emerald-50 text-emerald-700 border-emerald-200",
  inactive: "bg-slate-100 text-slate-400 border-slate-200",
  custom:   "bg-indigo-50 text-indigo-600 border-indigo-200",
  builtin:  "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export default function AdminBadge({ variant = "idle", children, className = "" }) {
  const cls = VARIANTS[variant] ?? VARIANTS.idle;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold border ${cls} ${className}`}>
      {children}
    </span>
  );
}
